import { render, staticRenderFns } from "./WeChatGroupManager.vue?vue&type=template&id=6cdce453&scoped=true"
import script from "./WeChatGroupManager.vue?vue&type=script&lang=js"
export * from "./WeChatGroupManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdce453",
  null
  
)

export default component.exports